import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Column } from '../../model/common/column';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { Select } from '@openng/optimus-ui/select';
import { DatePicker } from '@openng/optimus-ui/datepicker';

export type FilterEvent = {
  value: string | Date | null;
  field: string;
  matchMode?: string;
  operator?: string;
};

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, InputText, Select, DatePicker, ReactiveFormsModule],
})
export class TableFilterComponent {
  @Input() col!: Column;
  readonly filterEvent = output<FilterEvent>();
  calendarInputChanged = false;

  getStyleClass(col: Column) {
    if (col.formControl && col.formControl.invalid) {
      return 'lookup-filter-error ui-inputtext ui-corner-all ui-state-default ui-widget';
    } else {
      return 'ui-inputtext ui-corner-all ui-state-default ui-widget';
    }
  }

  emitInputFilter($event: Event, col: Column) {
    this.filterEvent.emit({
      value: (<HTMLInputElement>$event.target).value,
      field: col.field,
      matchMode: col.matchMode,
    });
  }

  emitCalendarFilter(value: Date | null, col: Column): void {
    this.calendarInputChanged = false;
    this.filterEvent.emit({
      value,
      field: col.field,
      matchMode: col.matchMode ? col.matchMode : 'equals',
    });
  }

  /** Emits the datepicker's own parsed value on blur, only after the user typed. */
  emitCalendarInputFilter(value: Date | null, col: Column): void {
    if (this.calendarInputChanged) {
      this.emitCalendarFilter(value, col);
    }
  }
}
